export const scrollToBottom = (containerRef, bottomRef, behavior = 'smooth') => {
  if (!containerRef?.current || !bottomRef?.current) return

  const container = containerRef.current
  const bottomElement = bottomRef.current

  // More reliable than scrollIntoView
  container.scrollTo({
    top: bottomElement.offsetTop - container.offsetTop,
    behavior,
  })
}

export const maintainScrollPosition = (containerRef, previousScrollHeight) => {
  if (containerRef.current) {
    containerRef.current.scrollTop = containerRef.current.scrollHeight - previousScrollHeight
  }
}

export const isNearBottom = (containerRef, threshold = 100) => {
  if (!containerRef.current) return false
  const { scrollTop, scrollHeight, clientHeight } = containerRef.current
  return scrollHeight - scrollTop - clientHeight < threshold
}
